// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\LogEvent\ApiLogEvent.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';

// LogEventData is the class that LogEvent serializes to/from
export interface LogEventData {
    EventId : number;
    PortCallId : number;
	
    Event : EventData | null;
    PortCall : PortCallData | null;
	
}

// LogEventOptions is the class which may be passed to the LogEvent constructor to define optional initial data values
export interface LogEventOptions {
    EventId : number;
    PortCallId : number;
	
    Event? : EventOptions | null;
    PortCall? : PortCallOptions | null;
	
}

export class LogEvent {
    public EventId : DataSignal<number>;
    public PortCallId : DataSignal<number>;
	
    public Event : DataSignal<Event | null>;
    public PortCall : DataSignal<PortCall | null>;
	

    constructor();
    constructor(data : LogEventOptions);
    constructor(data: LogEventOptions | null = null) {
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
	    
        this.Event = S.value<Event | null>(null);
        this.PortCall = S.value<PortCall | null>(null);
	    
    }

    static key(obj : LogEvent) {
        return obj.EventId() + '\u2618' + obj.PortCallId();
    }
    
    static dataKey(obj : LogEventOptions) {
        return obj.EventId + '\u2618' + obj.PortCallId;
    }

    static update(obj : LogEvent, data : LogEventOptions) {
        S.freeze(() => {
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/LogEvent.ts